<template>
  <!--Odabrani proizvodi za klijenta-->
  <section>
    <modal id="quick-preview-article" v-if="quickArticle">
      <div class="modal-body" slot="body">
        <quick-preview :key="quickArticle.id" />
      </div>
    </modal>
    <modal id="addCartModal" v-if="selectedArticle">
      <div slot="body" class="modal-body add-cart-box text-center">
        <p class="html-content" v-html="translations.addToCartSuccessMessage"></p>
        <h4 id="productTitle">
          {{ selectedArticle.title }}
        </h4>
        <img
          :src="`${baseUrl}${selectedArticle.imageUrl}`"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
        />
        <div class="btn-actions">
          <router-link :to="{ name: 'ShoppingCart' }" data-dismiss="modal">
            <button class="btn-primary">{{translations.goToShoppingCart}}</button>
          </router-link>
          <button class="btn-primary" data-dismiss="modal">
            {{translations.continueShopping}}
          </button>
        </div>
      </div>
    </modal>
    <div class="section-title">
      <h2>
        <router-link :to="{ name: 'UserArticles' }">
          {{ translations.userArticles }}
        </router-link>
      </h2>
    </div>

    <div class="row">
      <div
        class="col-xl-6 col-md-4 col-xl-5col custom-col"
        v-for="item in articles"
        :key="item.articleId"
      >
        <div class="product-default inner-quickview inner-icon product-item">
          <figure>
            <router-link
              :to="{ name: 'Article', params: { id: item.articleId, slug: slugify(item.title) } }"
            >
              <Photo :src="`${baseUrl}${item.imageUrl}`" />
            </router-link>
            <div class="label-group" style="position: absolute; top: 5px; left: 5px">
              <span
                v-if="getCurrentDiscount(item) != '0'"
                class="product-label label-cut"
                >{{ getCurrentDiscount(item) | percentage }}% </span
              >
            </div>
            <div class="btn-icon-group" v-if="!item.disableSelling">
              <button class="btn-icon btn-add-cart" @click="addToCart(item)">
                <i class="sicon-equalizer" v-if="item.hasAttributes" />
                <i class="icon-bag" v-else />
              </button>
            </div>
            <button
              class="btn btn-sm btn-quickview"
              data-toggle="modal"
              @click="getQuickArticle(item.articleId)"
            >
              {{ translations.quickPreview }}
            </button>
          </figure>
          <div class="product-details">
            <div class="category-wrap">
              <div class="category-list">
                 <router-link
                    class="product-category"
                    :to="{ name: 'Brand',
                    params: {
                      id: item.brand.brandId,
                      title: item.brand.title.replace(/\s+/g, '-')
                      }
                    }"
                    @click.native="trackConversionForBrand(item.brand.brandId,
                    item.brand.title.replace(/\s+/g, '-'))"
                  >
                    {{ item.brand.title }}
                  </router-link>
              </div>
              <a
                :class="{ active: item.isOnWishList }"
                class="btn-icon-wish"
                @click.stop.prevent="toggleWishlistItem(item.articleId)"
              >
                <i class="icon-heart" :class="{ 'icon-heart-1': item.isOnWishList }"></i>
              </a>
            </div>
            <h2 class="product-title" :title="item.title">
              <router-link
                :to="{ name: 'Article', params: { id: item.articleId, slug: slugify(item.title) } }"
              >
                {{ item.title }}
              </router-link>
            </h2>
            <div class="ratings-container">
              {{ translations.forms.labels.code }}: {{ item.code }}</div>
            <!-- End .product-container -->
            <div
              class="price-box"
              v-if="
                canViewPrices &&
                !item.disableSelling
              "
            >
              <span class="product-price">{{ getCurrentPrice(item) | money3WithCurrency }}</span>
              <span class="old-price" v-if="getOldPrice(item) > 0">
                {{ getOldPrice(item) | money3 }} KM
              </span>
            </div>
            <!-- End .price-box -->
          </div>
          <!-- End .product-details -->
        </div>
      </div>
    </div>

    <div class="row row-sm flex-row justify-content-end px-4 font-weight-bold">
      <router-link :to="{ name: 'UserArticles' }">
        {{ translations.viewAll }}
      </router-link>
    </div>
  </section>
</template>

<script>
import { translations, pager } from '@/mixins';
import config from '@/config';
import api from '@/services/api';
import slugify from '@/filters/slugify';
import helpers from '@/services/helpers';

import Photo from '@/components/shared/Image.vue';
import Modal from '@/components/shared/modal/Modal.vue';
import QuickPreview from '@/components/shared/article/QuickPreview.vue';

export default {
  name: 'UserArticles',
  mixins: [translations, pager],
  components: {
    Photo,
    Modal,
    QuickPreview,
  },
  data() {
    return {
      selectedArticle: null,
    };
  },
  computed: {
    articles() {
      return this.$store.getters.getUserArticles;
    },
    baseUrl() {
      return config.baseUrl;
    },
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
  },
  mounted() {
    this.$store.dispatch('getCustomerCustomizedArticles', {
      ...this.searchConfig,
      attributeValuesIds: [],
      brandIds: [],
      categoryIds: [],
      maxPrice: 100,
      minPrice: 1,
    });
  },
  methods: {
    slugify,
    getCurrentPrice(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;

      if (salePrice > 0 && salePrice < price) {
        return salePrice;
      }
      return price;
    },
    getCurrentDiscount(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;
      if (salePrice > 0 && salePrice < price) {
        return item.saleDiscountPercentage * -1;
      }
      if (matchedPP) {
        return (100 * (1 - (item.price / item.oldPrice))) * -1;
      }
      return 0;
    },
    getOldPrice(item) {
      const salePrice = item.salePrice || 0;
      const price = item.price || 0;
      const matchedPP = item.matchedPP || false;

      if (salePrice > 0 && salePrice < price) {
        return item.oldPrice;
      }
      if (matchedPP) {
        return item.oldPrice;
      }
      return 0;
    },
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getCustomerCustomizedArticles', {
          ...this.searchConfig,
          attributeValuesIds: [],
          brandIds: [],
          categoryIds: [],
          maxPrice: 100,
          minPrice: 1,
        });
        this.$store.dispatch('getWishList');
      });
    },
    getQuickArticle(articleId) {
      this.$store.dispatch('getQuickViewArticle', articleId).then(() => {
        this.$store.dispatch('getArticleVariations', articleId).then(() => {
          this.$store.dispatch('getAttributes', { retrieveAll: true });
          $('#quick-preview-article').modal('show');
        });
      });
    },
    addToCart(item) {
      if (item.hasAttributes) {
        this.$router.push({ name: 'Article', params: { id: item.articleId, slug: slugify(item.title) } });
        return;
      }
      this.selectedArticle = item;
      api
        .addToShoppingCart({
          articleId: item.articleId,
          quantity: item.minOrderQuantity || 1,
        })
        .then(() => {
          this.$store.dispatch('getShoppingCart');
          this.$toast.info(helpers.getAddToCartToastMessage(item));
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info, { timeout: 4000 });
          this.$store.dispatch('getShoppingCart');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-icon-wish {
  cursor: pointer;

  &.active {
    color: red;
  }
}

.product-default .product-title {
  display: block;
  max-width: 100%;
}

.product-item {
  .product-details {
    min-height: 135px !important;
    justify-content: flex-start;
  }
}

@media screen and (max-width: 800px) {
  .custom-col {
    flex: 0 0 50%; /* Take up 50% of the row width */
    max-width: 50%;
  }
}

.html-content a {
  color: #3598DB;
}
</style>
